module.exports = __webpack_public_path__ + "media/public/img/city-experiences-logo-48a38b9ade179a62ab5ab1ffa30f0b6f.svg";